import React from "react";
import { Box, Skeleton } from "@mui/material";
import OrganizationInformation from "./OrganizationInformation";
import OrgProfileCard from "../hiring/OrgProfileCard";
import { useAppSelector } from "../../../../redux/hooks";

const OrgSettingsSkeleton = () => (
  <Box
    sx={{
      background: '#1C1C1C',
      borderRadius: '8px',
      outline: '1px solid #2A2A2A',
      outlineOffset: '-1px',
      overflow: 'hidden'
    }}
  >
    {/* Header */}
    <Box sx={{ px: '25px', py: '20px', borderBottom: '1px solid #2A2A2A', display: 'flex', justifyContent: 'flex-end' }}>
      <Skeleton variant="rounded" width={120} height={40} sx={{ bgcolor: '#2A2A2A' }} />
    </Box>
    {/* Body */}
    <Box sx={{ background: '#151515', p: '25px', display: 'flex', flexDirection: 'column', gap: '25px' }}>
      <Box sx={{ background: '#1C1C1C', borderRadius: '8px', p: '25px', display: 'flex', gap: '20px' }}>
        <Skeleton variant="rounded" width={100} height={100} sx={{ bgcolor: '#2A2A2A', flexShrink: 0 }} />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Skeleton variant="rounded" height={40} sx={{ bgcolor: '#2A2A2A' }} />
          <Skeleton variant="rounded" height={40} sx={{ bgcolor: '#2A2A2A' }} />
          <Skeleton variant="rounded" height={24} width="60%" sx={{ bgcolor: '#2A2A2A' }} />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: '25px' }}>
        <Skeleton variant="rounded" height={145} sx={{ flex: 1, bgcolor: '#2A2A2A' }} />
        <Skeleton variant="rounded" height={145} sx={{ flex: 1, bgcolor: '#2A2A2A' }} />
      </Box>
    </Box>
  </Box>
);

const OrganizationSettings = () => {
  const orgDetails = useAppSelector((state) => state.orgDetails);

  if (orgDetails.error) {
    return <Box sx={{ color: '#FDFDFD', p: 2 }}>{orgDetails.errorText}</Box>;
  }

  if (orgDetails.data) {
    return (
      <>
        <OrganizationInformation data={orgDetails.data} />
        {/* DA-5090: shown only where Hiring is on; it renders nothing otherwise. */}
        <Box sx={{ background: '#151515', px: '25px', pb: '25px' }}>
          <OrgProfileCard />
        </Box>
      </>
    );
  }

  return <OrgSettingsSkeleton />;
};

export default OrganizationSettings;
